<template>
  <div class="hclub-sale-proccess container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <h3 class="text-center mb-4">
          ¿Estás listo para mejorar tu salud y estilo de vida?
          <br>
          <small>
            Hispano Club tiene la opción que tu y tu familia necesitan
          </small>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 features-container" v-if="!isSelling">
        <div id="features"  :style="{ 'background-image': 'url(' + bgImage + ')' }">
          <div id="title" class="p-2">
            <b>
              Recuerda, todas nuestras membresías incluyen:
            </b>
          </div>
          <ul style="font-size:0.8rem;">
            <li>Consulta Médica telefónica</li>
            <li>Red de Descuentos en Farmacias</li>
            <li>Descuentos en Servicio Dental</li>
            <li>Descuentos en Servicio Visual</li>
            <li>Descuentos en Servicios de Laboratorio</li>
            <li>Descuentos en Diagnóstico por Imagen</li>
            <li>Descuentos en Servicios Legales</li>
            <li>Red de Descuentos</li>
            <li>Descuentos en Alimentos y Restaurantes</li>
            <li>Descuentos en Ropa y Accesorios</li>
            <li>Descuentos en Servicio Automotriz</li>
            <li>Servicio de Asistencia Vial</li>
            <li>Pago de Servicios</li>
            <li>Servicios Adicionales</li>
          </ul>
        </div>
      </div>
      <!-- Insertar producto aquí -->
        <product
          v-for="(item, index) in selectedProducts"
          v-bind:key="index"
          :itemdata="item"
          :index="index"
          v-if="isSellingIndex === index || isSellingIndex === null"
        />
    </div>
    <!--
    <pre>
      {{isSelling}} -- {{isSellingIndex}}
    </pre>
    -->
  </div>
</template>

<script>
import Product from '@/components/Product'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      products: this.$store.state.demoProducts,
      selectedProducts: null
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    bgImage () {
      return require('@/assets/shadow_vert.png')
    }
  },
  mounted () {
    this.selectedProducts = this.products
    this.$store.dispatch('initSale', { action: 'recover' })
    this.$nextTick(() => {
    })
  },
  components: {
    Product
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
@import '@/scss/breakpoint.scss';
.hclub-sale-proccess {
  h1, h2, h3, h4, h5 {
    font-weight: normal !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  .v-switch-core {
    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.50);
    .v-switch-button {
      box-shadow: 0 1px 1px 0 rgba(0,0,0,0.50);
    }
  }
}
.features-container {
  display: none;
  @include breakpoint(md) {
    display: block;
  }
}
#features {
  padding-right: 34px;
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 30px 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue